import React from 'react';
import styled from 'styled-components';
import { CommonInputCss, Error, FormControlProps } from './Common';

const Container = styled.div`
  margin: 18px 0;
`;

const Input = styled.input`
  ${CommonInputCss}
`;

const FormControl: React.FC<FormControlProps> = ({
  placeholder,
  required,
  touched,
  error,
  ...props
}) => {
  return (
    <Container>
      <Input
        placeholder={required ? `${placeholder} *` : placeholder}
        required={required}
        {...props}
      />
      {touched && error && <Error>{error}</Error>}
    </Container>
  );
};

export default FormControl;
